import React from 'react';
import Button from '@mui/material/Button';
import CircularProgress from '@mui/material/CircularProgress';

const variants = {
    primary: '#F07F6D',
    secondary: '#3699FF',
    alert: '#F64E60'
};

function CustomizedButton({
    disabled = false,
    loading = false,
    dataTestId = 'button',
    label,
    variant = 'primary',
    width,
    className,
    onClick,
    children
}) {
    return (
        <Button
            data-testid={dataTestId}
            disabled={disabled}
            className={className}
            variant="contained"
            sx={{
                width: width ? `${width}px` : 'auto',
                height: {
                    xs: '32px',
                    sm: '50px'
                },
                backgroundColor: variants[variant],
                borderRadius: '10px !important',
                border: 'none',
                fontFamily: 'LexendDeca',
                fontSize: {
                    xs: '8px',
                    sm: '14px'
                },
                letterSpacing: '0.8px',
                transition: 'all 0.15s ease-in',
                scale: '1',
                textTransform: 'none',
                boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.3)',
                '&:hover': {
                    backgroundColor: variants[variant],
                    scale: '1.02'
                }
            }}
            onClick={onClick}
        >
            {loading ? (
                <CircularProgress
                    data-testid="loader"
                    size={20}
                    color="primary"
                    thickness={4}
                    sx={{
                        '& .MuiCircularProgress-colorPrimary': {
                            color: '#F07F6D !important'
                        }
                    }}
                />
            ) : label ? (
                label
            ) : (
                children
            )}
        </Button>
    );
}

export default CustomizedButton;
